/**
 * Utilidades de validación para campañas de correo
 */

export const ETIQUETAS_PERMITIDAS = [
  '{CLIENTE_NOMBRE}',
  '{CLIENTE_APELLIDO}',
  '{OT}',
  '{OT_LINK}',
  '{SERIAL_NUMBER}',
  '{FECHA_INGRESO}',
  '{FECHA_COMPRA}',
  '{FECHA_CIERRE}'
];

export const TIPO_OT_CHOICES = [
  { value: 'GARANTIA', label: 'Garantía' },
  { value: 'PRESUPUESTO', label: 'Presupuesto' }
];

export const FECHA_REFERENCIA_CHOICES = [
  { value: 'COMPRA', label: 'Compra' },
  { value: 'CIERRE', label: 'Cierre' }
];

export const OPERACION_CHOICES = [
  { value: 'SUMA', label: 'Suma (después de)' },
  { value: 'RESTA', label: 'Resta (antes de)' }
];

/**
 * Valida que solo se usen etiquetas permitidas en un texto
 * @param {string} texto - Texto a validar
 * @returns {Object} { valido: boolean, mensaje: string, etiquetasInvalidas: string[] }
 */
export function validarEtiquetas(texto) {
  if (!texto) {
    return { valido: true, mensaje: '', etiquetasInvalidas: [] };
  }

  // Buscar todas las etiquetas en formato {ETIQUETA}
  const regex = /\{[^{}]+\}/g;
  const etiquetasEncontradas = texto.match(regex) || [];
  
  // Filtrar etiquetas no permitidas
  const etiquetasInvalidas = etiquetasEncontradas.filter(
    etiqueta => !ETIQUETAS_PERMITIDAS.includes(etiqueta)
  );

  if (etiquetasInvalidas.length > 0) {
    const listaInvalidas = [...new Set(etiquetasInvalidas)].join(', ');
    return {
      valido: false,
      mensaje: `Etiquetas no permitidas: ${listaInvalidas}. Las etiquetas permitidas son: ${ETIQUETAS_PERMITIDAS.join(', ')}`,
      etiquetasInvalidas: [...new Set(etiquetasInvalidas)]
    };
  }

  return { valido: true, mensaje: '', etiquetasInvalidas: [] };
}

/**
 * Valida todos los campos de una campaña
 * @param {Object} campaign - Objeto de campaña
 * @returns {Object} { valido: boolean, errores: Object }
 */
export function validarCampaign(campaign) {
  const errores = {};

  // Validar nombre
  if (!campaign.nombre || campaign.nombre.trim() === '') {
    errores.nombre = 'El nombre de la campaña es obligatorio';
  } else if (campaign.nombre.length > 100) {
    errores.nombre = 'El nombre no puede exceder 100 caracteres';
  }

  // Validar tipo_ot
  if (!campaign.tipo_ot) {
    errores.tipo_ot = 'Debe seleccionar un tipo de OT';
  }

  // Validar fecha_referencia
  if (!campaign.fecha_referencia) {
    errores.fecha_referencia = 'Debe seleccionar una fecha de referencia';
  }

  // Validar operacion
  if (!campaign.operacion) {
    errores.operacion = 'Debe seleccionar una operación';
  }

  // Validar dias
  if (!campaign.dias || campaign.dias < 1) {
    errores.dias = 'El número de días debe ser mayor a 0';
  }

  // Validar variantes
  if (!campaign.variantes || campaign.variantes.length !== 3) {
    errores.variantes = 'Debe configurar las 3 variantes';
  } else {
    campaign.variantes.forEach((variante, index) => {
      const varianteErrores = {};

      // Validar asunto
      if (!variante.asunto || variante.asunto.trim() === '') {
        varianteErrores.asunto = 'El asunto es obligatorio';
      } else if (variante.asunto.length > 200) {
        varianteErrores.asunto = 'El asunto no puede exceder 200 caracteres';
      } else {
        const validacionAsunto = validarEtiquetas(variante.asunto);
        if (!validacionAsunto.valido) {
          varianteErrores.asunto = validacionAsunto.mensaje;
        }
      }

      // Validar cuerpo
      if (!variante.cuerpo || variante.cuerpo.trim() === '') {
        varianteErrores.cuerpo = 'El cuerpo es obligatorio';
      } else {
        const validacionCuerpo = validarEtiquetas(variante.cuerpo);
        if (!validacionCuerpo.valido) {
          varianteErrores.cuerpo = validacionCuerpo.mensaje;
        }
      }

      if (Object.keys(varianteErrores).length > 0) {
        errores[`variante_${index + 1}`] = varianteErrores;
      }
    });
  }

  return {
    valido: Object.keys(errores).length === 0,
    errores
  };
}
